import "react-toastify/dist/ReactToastify.css";
import { TitleWithDivider } from "@common/TitleWithDivider";
import { ConfirmCancelButtons } from "@components/Buttons/ConfirmCancelButtons";
import WarningModal from "@components/Modals/WarningModal";
import messages from "@constants/Messages";
import pageHeaders from "@constants/PageHeaders";
import LoadingIcon from "@common/LoadingIcon";
import { DepartmentGroupInfo } from "@pages/KAKELY/common/components/DepartmentGroupInfo";
import { useCreateDepartmentGroupPage } from "@pages/KAKELY/CreateDepartmentGroupPage/hooks/useCreateDepartmentGroup";

const CreateDepartmentGroupPage: React.FC = () => {
  const form = useCreateDepartmentGroupPage();

  return (
    <div className="container mx-auto p-4">
      <TitleWithDivider
        titleText={
          form.isNotMaster
            ? pageHeaders.KAKELY.departmentAdd
            : pageHeaders.KAKELY.departmentMasterAdd
        }
        useDivider={true}
      />
      {form.loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-brightness-50 min-h-screen">
          <div className="bg-white bg-opacity-95 p-5 rounded-lg shadow-lg flex items-center justify-center">
            <LoadingIcon />
          </div>
        </div>
      )}
      <div className="flex flex-row justify-end">
        {form.error && (
          <button
            className="button-default"
            type="button"
            onClick={form.handleOpenWarningModal}
          >
            {messages.generic.show_error}
          </button>
        )}
      </div>
      <form
        className="mayo-card-body border border-text-field-border p-4 mt-4"
        onSubmit={form.handleSave}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      >
        <DepartmentGroupInfo
          createChild={form.isCreateChild}
          department={form.department}
          errors={form.errors}
          updateError={form.updateError}
          handleInputChange={form.handleInputChange}
        ></DepartmentGroupInfo>

        <WarningModal
          title={messages.generic.error_modal_title}
          body={form.error}
          confirmText={""}
          cancelText="戻る"
          isOpen={form.warningModalOpen}
          onRequestClose={form.handleCloseWarningModal}
        ></WarningModal>

        <ConfirmCancelButtons
          confirmText={"作成"}
          onCancel={form.onCancel}
          form={true}
        ></ConfirmCancelButtons>
      </form>
    </div>
  );
};

export default CreateDepartmentGroupPage;
